<template>
    <div class="cursus-field">
        <template v-if="label || $slots.label">
            <label :for="resolvedId">
                <slot name="label">
                    {{ label }}
                </slot>
                <template v-if="required">*</template>
            </label>
        </template>
        <slot :id="resolvedId" :error="hasError" v-bind="{ name }">
            <input
                :id="resolvedId"
                :name="resolvedName"
                class="form-control"
                :class="{ 'is-invalid': hasError }"
                v-bind="$attrs"
                @focus="handleFocus"
                @blur="handleBlur"
                @input="handleInput"
            >
        </slot>
        <template v-if="hasError">
            <div class="invalid-feedback d-block">
                <template v-for="error in fieldErrors">
                    <div>{{ error }}</div>
                </template>
            </div>
        </template>
        <template v-if="$slots.help">
            <div class="text-muted small mt-1">
                <slot name="help"/>
            </div>
        </template>
    </div>
</template>

<script>
    import { fieldErrors, fieldNameAttribute } from "../util/form";

    export default {
        props: {
            id: String,
            label: String,
            name: String,
            errors: Object,
            required: Boolean,
        },
        computed: {
            resolvedId() {
                return this.id ?? this.name;
            },
            resolvedName() {
                return fieldNameAttribute(this.name);
            },
            hasError() {
                return this.fieldErrors?.length > 0;
            },
            fieldErrors() {
                return fieldErrors(this.errors, this.name);
            }
        },
        methods: {
            handleInput(e) {
                this.$emit('input', e.target.value);
            },
            handleFocus(e) {
                this.$emit('focus', e);
            },
            handleBlur(e) {
                this.$emit('blur', e);
            },
        }
    }
</script>
